import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { inject } from 'helpers/mobx'
import { getGenderText } from 'helpers/seo'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import { appendParameters, removeAllParameters } from 'helpers/url'
import { getPrevNextLinks } from 'pages/Brand/components/DocumentHead/helpers'
import React, { FC } from 'react'
import { normalizeHreflangs } from 'store/normalizer/meta.normalizer'

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default inject(store => {
  const t = store.t
  const seo = store.outfitOverviewStore.seo
  const outfitCategory = store.outfitOverviewStore.currentCategory?.name
  const isCurrentCategoryRoot =
    store.outfitOverviewStore.currentCategory &&
    store.outfitOverviewStore.isCurrentCategoryRoot

  const title = t('{{outfitCategory}} Outfits online kaufen | ABOUT YOU', {
    outfitCategory:
      isCurrentCategoryRoot || !outfitCategory
        ? t('Hochwertige')
        : outfitCategory,
  })

  const description = isCurrentCategoryRoot
    ? t(
        'Hochwertige Outfits versandkostenfrei bei ABOUT YOU bestellen. Große Outfit Auswahl {{forGender}} ✓Kostenlose Retoure ✓Zahlung auf Rechnung',
        {
          forGender: getGenderText({ gender: store.userStore.gender, t }),
        },
      )
    : t(
        '{{outfitCategory}} Outfits versandkostenfrei bei ABOUT YOU bestellen. Große {{outfitCategory}} Outfit Auswahl {{forGender}} ✓Kostenlose Retoure ✓Zahlung auf Rechnung',
        {
          outfitCategory: isCurrentCategoryRoot
            ? t('Hochwertige')
            : outfitCategory,
          forGender: getGenderText({ gender: store.userStore.gender, t }),
        },
      )

  const hreflangs = normalizeHreflangs(seo.hreflangs)
  const currentUrl = removeAllParameters(store.urlManagerStore.href)
  const currentPage = store.outfitOverviewStore.pagination.currentPage || 1
  const totalPages = store.outfitOverviewStore.pagination.totalPages

  const canonicalUrl =
    currentPage > 1
      ? appendParameters(currentUrl, { page: currentPage })
      : currentUrl

  const paginationLinks = getPrevNextLinks({
    currentUrl,
    currentPage,
    totalPages,
  })

  const links = [...paginationLinks, ...hreflangs]

  return {
    title,
    description,
    renderHreflangs: true,
    renderMobileAlternate: true,
    links,
    robots: 'index, follow',
    customTitleTemplate: true,
    canonicalUrl,
  }
})(DocumentHead)
